export function SubmissionStatusTimeline({ currentStatus = "submitted", submittedAt, reviewNotes = "", testId = "submission-status-timeline" }) {
  const steps = [
    { key: "submitted", label: "Submitted" },
    { key: "under_review", label: "Under Review" },
    { key: "more_info_requested", label: "More Info Needed" },
    { key: "rejected", label: "Rejected" },
    { key: "approved", label: "Approved" },
  ];

  const currentIndex = Math.max(0, steps.findIndex((step) => step.key === currentStatus));

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid={testId}>
      <p className="text-xs font-heading uppercase tracking-[0.15em] text-muted-foreground mb-4">Submission Status Timeline</p>
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-3">
        {steps.map((step, idx) => {
          const isCurrent = idx === currentIndex;
          const isPast = idx < currentIndex;
          return (
            <div key={step.key} className={`rounded-lg border p-3 text-sm ${isCurrent ? 'border-court-orange bg-court-orange/5' : isPast ? 'border-green-200 bg-green-50' : 'border-slate-200 bg-slate-50'}`}>
              <p className={`font-heading text-xs uppercase tracking-[0.15em] ${isCurrent ? 'text-court-orange' : isPast ? 'text-green-700' : 'text-slate-500'}`}>{step.label}</p>
              <p className="text-xs mt-1 text-muted-foreground">{isCurrent ? 'Current' : isPast ? 'Completed' : 'Pending'}</p>
              {idx === 0 && submittedAt && <p className="text-[10px] mt-2 text-muted-foreground">{submittedAt.slice(0, 10)}</p>}
              {step.key === currentStatus && reviewNotes && <p className="text-[10px] mt-2 text-muted-foreground">{reviewNotes}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
}